import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazySpaceReportsSiteSettings: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceReports" */ '../src/SpaceReports/SpaceReports.tsx'
			)
		).SpaceReports,
});

export { ADMIN_SPACE_REPORT_SCREEN } from '../src/SpaceReports/analytics.ts';
